import axios from "axios";
import { apiUrl } from '../constant'

const getPermissionByEmailId = () => {
  return axios.get(`${apiUrl}/api/employeepermission`);
};
export const sidebarservice = {
  getPermissionByEmailId
}